import { appConfig } from './app-config';

export type AgentLayoutId = 'onboarding' | 'generic' | 'cleanup';

export interface AgentConfig {
  id: string;
  name: string;
  description: string;
  icon?: string;
  deploymentUrl: string;
  assistantId: string;
  layoutId: AgentLayoutId;
  /** Title shown in the chat header */
  title: string;
  /** Welcome message shown when chat is empty */
  welcomeMessage: string;
  /** Secondary welcome message */
  welcomeDescription: string;
  /** Placeholder text for chat input */
  inputPlaceholder: string;
  /** Optional getting started hint shown below welcome description */
  gettingStartedHint?: string;
}

export const AGENT_REGISTRY: AgentConfig[] = [
  {
    id: 'onboarding-agent',
    name: 'Onboarding Assistant',
    description: 'Guide through PagerDuty platform setup — users, teams, schedules, and escalation policies.',
    icon: 'DoorOpen',
    deploymentUrl: appConfig.ONBOARDING_AGENT_URL ?? appConfig.API_BASE_URL,
    assistantId: 'agent',
    layoutId: 'onboarding',
    title: 'PagerDuty Operations Cloud Onboarding Assistant',
    welcomeMessage: "Welcome! I'm here to help you set up PagerDuty with best practices and confidence.",
    welcomeDescription: "Whether you're creating resources through conversation or uploading configurations via CSV, I'll guide you every step of the way to build a production-ready incident response system.",
    inputPlaceholder: 'Ask me anything about setting up PagerDuty...',
  },
  {
    id: 'optimize-clean-up-agent',
    name: 'Optimize and Clean up Assistant',
    description: 'Audit and optimize your existing PagerDuty configuration for better efficiency.',
    icon: 'BrushCleaning',
    deploymentUrl: appConfig.CLEANUP_AGENT_URL ?? appConfig.API_BASE_URL,
    assistantId: 'agent',
    layoutId: 'cleanup',
    title: 'PagerDuty Optimize & Clean Up Assistant',
    welcomeMessage: "Welcome! I'm here to help you audit and optimize your PagerDuty configuration.",
    welcomeDescription: "I'll analyze your teams, services, schedules, and escalation policies to identify cleanup opportunities and configuration improvements.",
    inputPlaceholder: 'Tell me which team to analyze (e.g., "Analyze the Platform Engineering team")',
    gettingStartedHint: "To get started, tell me which team you'd like to analyze. I'll run a rapid discovery and guide you through the cleanup process step by step.",
  },
];

export const getAgentById = (id: string): AgentConfig | null =>
  AGENT_REGISTRY.find((a) => a.id === id) ?? null;
